import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { FaRegEye, FaPen, FaTrash, FaPlus, FaTools, FaGlobeAmericas } from 'react-icons/fa'

import { TABLE_CONFIGS } from './constants'
import { useUser } from '../../utilities/helper'

function LocationUnitTypes(props) {
  const { user } = useUser()
  const locationCode = props?.match?.params?.location_code
  const [location, setLocation] = useState(null)
  const [unitTypes, setUnitTypes] = useState([])
  const [unitFilters, setUnitFilters] = useState([])
  const [loading, setLoading] = useState(true)
  const [savingAll, setSavingAll] = useState(false)

  let locationHeaders = [...TABLE_CONFIGS]
  if (user.is_CS_role) {
    locationHeaders = TABLE_CONFIGS.filter(
      (item) => !['ach_enabled', 'coming_soon', 'sboa', 'sboa_brochure'].includes(item.key)
    )
  }

  // Add unit filter columns to headers (use filter_key for relation semantics)
  const unitFilterHeaders = unitFilters.map(filter => ({
    key: `filter_${filter.filter_key}`,
    title: filter.name,
    className: 'text-center',
    minWidth: 100,
    isFilter: true,
    filterKey: filter.filter_key,
    filterId: filter.id
  }))

  // Add Actions column header
  const actionsHeader = {
    key: 'actions',
    title: '',
    className: 'text-center',
    minWidth: 100
  }

  // Combine regular headers with unit filter headers and actions
  const allHeaders = [...locationHeaders, ...unitFilterHeaders]

  const fetchAllData = async () => {
    try {
      setLoading(true)
      const locations = await axios.get(`/api/locations?location_code=${locationCode}`)
      const locationData = locations?.data
      setLocation(locationData)
      console.log(locationData, "locationData")
      
      const listUnitTypesWithNotes = await axios.get(`/api/location_unittypes?location_code=${locationCode}`)
      console.log('Unit Types Response:', listUnitTypesWithNotes.data)
      setUnitFilters(listUnitTypesWithNotes.data.available_filters || [])

      const response = await axios.post(`/api/ssm/GetLocationUnitTypes`, { location_code: locationCode })
      const listUnitTypes = response.data?.LocationUnitTypes?.UnitType || []

      const listTypes = listUnitTypes.map((unitType) => {
        const existingData = listUnitTypesWithNotes.data.unit_types?.find((item) => item.unit_type_id === unitType.UnitTypeId[0])
        return {
          location_code: locationCode,
          location_name: locationData?.name,
          location_address: locationData?.address,
          unit_type_id: unitType.UnitTypeId[0],
          unit_type_code: unitType.UnitTypeCode[0],
          category_name: unitType.CategoryName[0],
          note: existingData?.note || '',
          unit_filters: existingData?.unit_filters || [],
          selected_unit_filter_ids: existingData?.unit_filters?.map(f => f.id) || [],
          selected_unit_filter_keys: existingData?.unit_filters?.map(f => f.filter_key) || [],
        }
      })

      console.log('Unit Types:', listTypes)
      setUnitTypes(listTypes)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSaveNote = async (unitTypeId, note, unitFilterIds, unitFilterKeys) => {
    const response = await axios.post(`/api/location_unittypes`, {
      location_code: locationCode,
      unit_type_id: unitTypeId,
      note,
      unit_filter_ids: unitFilterIds,
      unit_filter_keys: unitFilterKeys,
    })
    if (response.status === 200) {
      alert('Data saved successfully')
      // Refresh the data to show updated unit filters
      fetchAllData()
    } else {
      alert('Failed to save data')
    }
  }

  const handleSaveAll = async () => {
    try {
      setSavingAll(true)
      const payloads = unitTypes.map(ut => ({
        location_code: locationCode,
        unit_type_id: ut.unit_type_id,
        note: ut.note,
        unit_filter_ids: ut.selected_unit_filter_ids,
        unit_filter_keys: ut.selected_unit_filter_keys,
      }))
      await Promise.all(
        payloads.map(p => axios.post(`/api/location_unittypes`, p))
      )
      alert('All changes saved successfully')
      fetchAllData()
    } catch (err) {
      console.error('Save all failed', err)
      alert('Failed to save all changes')
    } finally {
      setSavingAll(false)
    }
  }

  useEffect(() => {
    fetchAllData()
  }, [])

  if (loading) {
    return (
      <div className='container-fluid mt-2'>
        <div className='d-flex justify-content-center'>
          <div className='spinner-border' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='container-fluid mt-2'>
      <div className='table-title'>
        <div className='row'>
          <div className='col-12 d-flex justify-content-between'>
              <div className=''>
                <h3>Unit Types</h3>
                <span>
                  {location?.location_code} - {location?.name} - {location?.address} (<small className='text-muted'>
                    Unit Filters: {unitFilters.length} | Unit Types: {unitTypes.length}
                  </small>)
                </span>
              </div>
              <div className='mt-4'>
                <button
                  type='button'
                  className='btn btn-success btn-sm'
                  onClick={handleSaveAll}
                  disabled={savingAll}
                >
                  {savingAll ? 'Saving...' : 'Save'}
                </button>
              </div>
          </div>
        </div>
      </div>
      <div className='table-responsive'>
        <div className='table-wrapper'>
          <table className='table table-striped table-hover table-bordered bg-white custom-table'>
            <thead>
              <tr>
                {allHeaders.map((header) => (
                  <th style={{ minWidth: header.minWidth }} key={header.key} className={header.className || null}>
                    {header.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {unitTypes.map((unitType, index) => (
                <tr key={unitType.unit_type_id}>
                  <td className='text-center'>{index + 1}</td>
                  <td className='text-center'>{unitType.unit_type_id}</td>
                  <td className='text-center'>{unitType.unit_type_code}</td>
                  <td className='text-center'>{unitType.category_name}</td>
                  <td className=''>
                    <textarea
                      type='text'
                      className='form-input w-100'
                      defaultValue={unitType.note}
                      onChange={(e) => (unitType.note = e.target.value)}
                      rows={3}
                      maxLength={200}
                      style={{ width: '160px', height: '100px' }}
                    />
                  </td>
                  {/* Unit filter checkbox columns */}
                  {unitFilters.map((filter) => (
                    <td key={`filter_${filter.filter_key}`} className='text-center'>
                      <div className='form-check d-flex justify-content-center'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          checked={unitType.selected_unit_filter_ids.includes(filter.id)}
                          onChange={(e) => {
                            const updatedUnitTypes = unitTypes.map(ut => {
                              if (ut.unit_type_id === unitType.unit_type_id) {
                                let newSelectedIds = [...ut.selected_unit_filter_ids]
                                let newSelectedKeys = [...(ut.selected_unit_filter_keys || [])]
                                if (e.target.checked) {
                                  if (!newSelectedIds.includes(filter.id)) {
                                    newSelectedIds.push(filter.id)
                                  }
                                  if (!newSelectedKeys.includes(filter.filter_key)) {
                                    newSelectedKeys.push(filter.filter_key)
                                  }
                                } else {
                                  newSelectedIds = newSelectedIds.filter(id => id !== filter.id)
                                  newSelectedKeys = newSelectedKeys.filter(k => k !== filter.filter_key)
                                }
                                return { ...ut, selected_unit_filter_ids: newSelectedIds, selected_unit_filter_keys: newSelectedKeys }
                              }
                              return ut
                            })
                            setUnitTypes(updatedUnitTypes)
                          }}
                        />
                      </div>
                    </td>
                  ))}
                  {/* Actions column */}
                  <td className='text-center d-none'>
                    <button
                      type='button'
                      className='btn btn-primary btn-sm'
                      onClick={() => handleSaveNote(unitType.unit_type_id, unitType.note, unitType.selected_unit_filter_ids, unitType.selected_unit_filter_keys)}
                    >
                      <i className='fas fa-save'></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default LocationUnitTypes
